import { StateCreator } from 'zustand'
import { TableType, UsersStore } from '../../@types/store'

const createUsersSlice: StateCreator<
  UsersStore,
  [["zustand/devtools", never]],
  [],
  UsersStore
> = (set) => ({
  users: {
    columns: [],
    data: [],
    next: false,
    previous: false,
    count: 0
  },
  setUsers: (data: TableType) => set(() => ({ users: data }), false, 'setUsers'),
  setNewUser: (element: object) => set((state) => ({
    users: { ...state.users, data: [...state.users.data, element] },
  }), false, 'setNewUser'),
})

export default createUsersSlice
